import React from 'react'
import Skeleton from 'react-loading-skeleton'

const ProductItemSkeleton = () => {
  return (
    <div className="bg-white rounded-2xl overflow-hidden shadow-md border-t-2 border-[#f9fafb] mt-10">
      <div className="relative h-[140px] md:h-[180px]">
        <Skeleton height="100%" />
      </div>

      <div className="p-3 md:p-5">
        <div className="mb-1 min-h-[18px]">
          <Skeleton width={80} height={13} />
        </div>

        <div className="h-[2.6em] md:h-[2.5em] mb-3">
          <Skeleton count={2} height={15} />
        </div>

        <div className="flex items-center gap-1.5 md:gap-2 min-h-[34px] min-[1199px]:min-h-[40px] mb-3">
          <Skeleton width={60} height={19} />
          <Skeleton width={40} height={13} />
        </div>

        <div className="flex gap-1 md:gap-2 justify-between items-center">
          <Skeleton
            width={28}
            height={20}
            className="md:!w-[42px] md:!h-[32px] rounded-full flex-shrink-0"
          />
          <Skeleton
            width={138}
            height={20}
            className="md:!h-[32px] rounded-full flex-shrink-0"
          />
          <Skeleton height={32} className="flex-1 md:!h-[40px] rounded-full" />
        </div>
      </div>
    </div>
  )
}

export default ProductItemSkeleton
